export default {"src":"/_next/static/media/seller-profile.98b6a854.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};